/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable no-nested-ternary */
import React, { useRef, useEffect, useMemo } from "react";
import { useRouter } from "next/router";
import { useTheme } from "styled-components";
import config from "config";
import { mxpTrackSection } from "components/ThemedComponent/mixPannelEvents";
import { getUrlPath } from "utils/helpers";
import { useUser } from "hooks";
import { USER_PLATFORM } from "constants/tracking";
import ChevronRightGrey from "assets/svgs/ChevronRightGrey";
import Mixpanel from "utils/Mixpanel";
import { isUserLoggedIn } from "utils";
import JobCardTags from "components/RevampFeedDetails/common/components/JobCardTags";
import { useWindowResize } from "utils/hooks";
import { getIsJobAppliedFromLS } from "utils/commonUtils";
import clsx from "clsx";
import Image from "next/image";
import {
	DISCOVERY_TABS_LABELS,
	LOCAL_STORAGE_KEYS,
	SESSION_STORAGE_KEYS,
} from "utils/constants";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import { ImageWrapper, InterviewLineContainer, JobCompany } from "./JobListCard.styles";

const JobListCard = (props) => {
	const visibleRef = useRef(null);
	const {
		job,
		filterStates,
		row,
		column,
		pageNumber,
		filterCount,
		search = false,
		isJobFeedPage,
		pageName,
		fullWidth = true,
		isRenderedInModule = false,
		moduleTrackData = {},
	} = props;
	const router = useRouter();
	const { vendor } = useTheme();
	const { isLoggedIn } = useUser();
	const [isMobileView] = useWindowResize();
	const { discoveryTabs } = useJobFeedStore();
	const { showTabs, activeTabId } = discoveryTabs;

	// const { selectedJobFeedType } = useContext(JobFeedContext);
	const baseUrl = router.pathname?.startsWith("/microsite")
		? `/microsite/${vendor}`
		: "";

	const jobUrl = () => {
		let urlString = `${baseUrl}/${(job?.public_url || job?.public_url_v2)?.replace(
			config.websiteUrl,
			""
		)}`;

		if (isUserLoggedIn()) {
			urlString += `?c_id=${isUserLoggedIn()}`;
		}
		if (search) {
			if (isUserLoggedIn()) {
				urlString += "&search=true";
			} else {
				urlString += "?search=true";
			}
		}
		if (showTabs && activeTabId) {
			urlString += `&source=${DISCOVERY_TABS_LABELS[activeTabId]}`;
		}
		return urlString;
	};

	const isJobApplied = useMemo(() => getIsJobAppliedFromLS(job?.id), [job?.id]);
	const trackEvent = async (eventName) => {
		const { default: allCategories } = await import("cms/category-data");

		const jobCategory = allCategories.find((cat) => cat?.id === job?.category_id);

		Mixpanel.track(eventName, {
			section: mxpTrackSection.JOB_CARD,
			page: getUrlPath(),
			isLoggedIn,
			jobId: job?.id,
			JobTitle: job?.title,
			category: jobCategory?.slug,
			area: job?.address?.area,
			city: job?.address?.city?.name,
			maxSalary: job?.max_salary,
			minSalary: job?.min_salary,
			// selectedJobFeedType,
			userPlatform: USER_PLATFORM[vendor],
			"Job Board Type": job?.is_external_job ? "Non Apna Job" : "Apna Job",
			earning_potential: job?.earning_potential,
			is_wfh: job?.is_wfh,
			Job_company_name: job?.organization?.name,
			source: getPageSource(),
			tags_shown: job?.ui_tags?.map((tag) => tag?.text),
			"External Job Type": job?.is_external_job ? job?.job_info?.job_lead_type : "",
			"Search ID": router?.query?.search
				? localStorage.getItem(LOCAL_STORAGE_KEYS.SEARCH_SESSION_ID)
				: "",
			...moduleTrackData,
		});
	};

	const getPageSource = () => {
		if (showTabs && activeTabId) return DISCOVERY_TABS_LABELS[activeTabId];
		if (pageName === "job_application_successful_status_screen") {
			return "similar job application screen";
		}
		if (pageName === "job_application_unsuccessful_status_screen") {
			return "application unsuccessful screen";
		}
		if (isJobFeedPage) {
			return "Job Feed Web";
		}
		return "Job Search Web";
	};

	const onCardClick = () => {
		trackEvent("Job Card Click");
		if (moduleTrackData && Object.keys(moduleTrackData).length > 0) {
			sessionStorage.setItem(
				SESSION_STORAGE_KEYS.MODULE_TRACKING_DATA,
				JSON.stringify(moduleTrackData)
			);
		}

		if (isMobileView) window.open(jobUrl(), "_self");
		if (!isMobileView) window.open(jobUrl(), "_blank");
	};
	useEffect(() => {
		const options = {
			root: null, // Use the viewport as the root
			rootMargin: "0px",
			threshold: 0.5, // Set the threshold value as per your requirement (0.5 means at least 50% of the element is visible)
		};

		const callback = (entries, observer) => {
			entries.forEach(async (entry) => {
				if (entry.isIntersecting) {
					// The element is visible in the viewport
					// Track MP event on visible jobs:
					const { default: allCategories } = await import("cms/category-data");
					const jobCategory = allCategories.find(
						(cat) => cat?.id === job?.category_id
					);
					Mixpanel.track("Job Impression Web", {
						section: mxpTrackSection.JOB_CARD,
						page: getUrlPath(),
						isLoggedIn,
						jobId: job?.id,
						JobTitle: job?.title,
						category: jobCategory?.slug,
						area: job?.address?.area,
						city: job?.address?.city?.name,
						maxSalary: job?.max_salary,
						minSalary: job?.min_salary,
						// selectedJobFeedType,
						userPlatform: USER_PLATFORM[vendor],
						"Selected Filters": filterStates,
						"Is filter applied": !!filterCount,
						"x position": row,
						"y position": column,
						"Page No": pageNumber,
						"Job Board Type": job?.is_external_job
							? "Non Apna Job"
							: "Apna Job",
						earning_potential: job?.earning_potential,
						is_wfh: job?.is_wfh,
						Job_company_name: job?.organization?.name,
						source: getPageSource(),
						tags_shown: job?.ui_tags?.map((tag) => tag?.text),
						"External Job Type": job?.is_external_job
							? job?.job_info?.job_lead_type
							: "",
						"Search ID": router?.query?.search
							? localStorage.getItem(LOCAL_STORAGE_KEYS.SEARCH_SESSION_ID)
							: "",
						...moduleTrackData,
					});
					observer.unobserve(entry.target);
				}
			});
		};

		const observer = new IntersectionObserver(callback, options);

		if (visibleRef.current) {
			observer.observe(visibleRef.current);
		}

		return () => {
			if (visibleRef.current) {
				observer.unobserve(visibleRef.current);
			}
		};
	}, []);
	const topJobHighlight =
		job?.job_highlights?.find((highlight) => highlight.on_top) || {};
	const bottomJobHighlights = job?.job_highlights?.filter(
		(highlight) => !highlight?.on_top
	);
	const renderSalaryString = () => {
		if (job?.is_external_job) {
			return job?.salary_detail || "Not disclosed";
		}
		if (
			job?.is_incentives_involved &&
			job?.salary_type === 2 &&
			job?.earning_potential
		) {
			return `₹${job?.earning_potential?.toLocaleString()} monthly*`;
		}
		if (
			job?.is_incentives_involved &&
			(job?.min_salary || job?.min_salary === 0) &&
			job?.earning_potential
		) {
			return `₹${job?.min_salary?.toLocaleString()} - ₹${job?.earning_potential?.toLocaleString()} monthly*`;
		}

		if ((job?.min_salary || job?.min_salary === 0) && job?.earning_potential)
			return `₹${job?.min_salary?.toLocaleString()} - ₹${job?.earning_potential?.toLocaleString()} monthly`;

		return "";
	};

	return (
		<div
			className={clsx(
				`min-h-full cursor-pointer rounded-lg border border-solid border-[#E8E7EA] bg-white p-[12px] shadow-100 md:m-0`,
				{
					"w-[300px]": !fullWidth,
				}
			)}
			onClick={onCardClick}
			ref={visibleRef}
			data-testid="job-card"
		>
			<div className="relative h-full w-full space-y-3">
				{/* Top highlights section */}
				{topJobHighlight?.heading && !isRenderedInModule && (
					<div
						className={clsx(
							"mb-3 flex items-center justify-between gap-[2px] rounded  pl-[8px]"
						)}
						style={{
							background: `linear-gradient(90deg, ${
								topJobHighlight?.background_colour
									? topJobHighlight?.background_colour
									: "#fff"
							} 0%, rgba(255,255,255,1) 100%)`,
						}}
					>
						<div className="flex items-center">
							<img
								src={topJobHighlight?.icon_link}
								alt=""
								className="h-[16px w-[16px]"
							/>
							<p
								className="m-0 flex-1 text-[14px]"
								style={{ color: topJobHighlight?.text_colour }}
								data-testid="job-card-top-highlight"
							>
								{topJobHighlight?.heading}
							</p>
						</div>

						{/* Add element to show job is applied */}
						{isJobApplied && isUserLoggedIn() && (
							<div className="w-max rounded-[2px] bg-[#F2F2F3] px-[8px] text-[14px] leading-[20px] text-[#827485]">
								Applied
							</div>
						)}
					</div>
				)}
				<div className="flex justify-between">
					<div className="flex w-full items-start">
						<div className="pt-[4px]">
							{job?.organization?.logo_url ? (
								<ImageWrapper>
									<Image
										src={job?.organization?.logo_url}
										alt="company-logo"
										height={32}
										width={32}
										layout="fixed"
										quality={100}
										unoptimized
										className="object-cover"
									/>
								</ImageWrapper>
							) : (
								<img
									src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/Company_icon_webp.webp"
									alt=""
									className="mr-2 h-[32px] w-[32px]"
								/>
							)}
						</div>
						<div
							className={clsx("w-full", {
								"max-w-[200px]": isRenderedInModule,
								"flex-1": !isRenderedInModule, // Ensure it only stretches when not in a module
							})}
						>
							<p
								className={clsx(
									"m-0 w-full text-[16px] font-semibold leading-[24px]",
									{
										"max-w-[200px] truncate": isRenderedInModule,
									}
								)}
								title={job?.name || job?.title}
								data-testid="job-title"
							>
								{job?.name || job?.title}
							</p>
							<JobCompany data-testid="company-title">
								{job?.organization?.name}
							</JobCompany>
						</div>

						{/* This applied sign is only shown when the applied sign in highlight section above is not shown. */}
						{isJobApplied &&
							!topJobHighlight?.heading &&
							isUserLoggedIn() && (
								<div className="ml-auto w-max rounded-[2px] bg-[#F2F2F3] px-[8px] text-[14px] leading-[20px] text-[#827485]">
									Applied
								</div>
							)}
					</div>
					{!isJobApplied && (
						<div>
							<ChevronRightGrey fill="#1F8268" />
						</div>
					)}
				</div>
				<div className="space-y-[4px]">
					{job?.is_wfh ? (
						<div className="flex items-center gap-1">
							<div className="flex h-[16px] w-[16px] items-center justify-center">
								<img
									src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/home.png"
									alt="wfh"
								/>
							</div>
							<p
								className="m-0 text-sm leading-[20px] text-[#8C8594]"
								data-testid="job-location"
							>
								Work from home
							</p>
						</div>
					) : (
						<div className="flex items-center gap-1">
							<div className="flex h-[16px] w-[16px] items-center justify-center">
								<img
									src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/Location_icon.webp"
									alt=""
								/>
							</div>
							<p
								className="m-0 text-sm leading-[20px] text-[#8C8594]"
								data-testid="job-location"
							>
								{job?.location_name}
							</p>
						</div>
					)}

					{renderSalaryString() && (
						<div className="flex items-center gap-[4px]">
							<div className="flex h-[16px] w-[16px] items-center justify-center">
								<img
									src="https://storage.googleapis.com/mumbai_apnatime_prod/jobs_page/Salary_icon.webp"
									alt=""
								/>
							</div>
							<p
								className="m-0 truncate text-sm leading-[20px] text-[#8C8594]"
								data-testid="job-salary"
							>
								{renderSalaryString()}
							</p>
						</div>
					)}
				</div>

				<JobCardTags tags={job?.ui_tags} />
				{/* Job Highlights */}
				{Array.isArray(bottomJobHighlights) && bottomJobHighlights.length > 0 && (
					<div className="scrollbarHide scrollbarHide::-webkit-scrollbar flex  w-full flex-row items-center gap-[4px] overflow-x-scroll">
						{bottomJobHighlights.map((highlight, index) => (
							<div
								className={clsx(`m-[0] flex items-center gap-2 rounded`, {
									"ml-[12px]": index !== 0,
								})}
								style={{
									background: `linear-gradient(90deg, ${
										highlight?.background_colour
											? highlight?.background_colour
											: "#fff"
									} 0%, rgba(255,255,255,1) 100%)`,
								}}
							>
								<div className="h-[16px] w-[16px]">
									<img src={highlight?.icon_link} alt="" />
								</div>
								<p
									className="m-0 text-[14px]"
									style={{ color: highlight?.text_colour }}
									data-testid="job-card-bottom-highlight"
								>
									{highlight?.heading}
								</p>
							</div>
						))}
					</div>
				)}
				{job?.job_application_mode?.mode === "throttled" ? (
					<InterviewLineContainer>
						{job.job_application_mode.message}
					</InterviewLineContainer>
				) : null}
			</div>
		</div>
	);
};

export default JobListCard;
